<template>
  <div class="pt-20px publish-form">
    <div class="flex justify-between gap-[20px] p-[16px]">
      <div class="w-[210px]">
        <Resource :src="data?.cover" class="cover" />
        <div class="text-font-80 text-center mt-[10px]">{{ data?.title }}</div>
      </div>
      <div class="flex-1">
        <div class="font-bold text-[16px] text-font-1">
          {{ $t('fa-bu-shi-pin-rang-geng-duo-ren-kan-dao-ni-de-zuo-pin-ba') }}
        </div>
        <a-form
          ref="formRef"
          name="custom-validation"
          :model="publishForm"
          v-bind="layout"
          class="mt-[15px]"
          :colon="false"
          :rules="rules"
          :hideRequiredMark="true"
          @finish="onPublish"
        >
          <a-form-item name="platform_type">
            <a-form-item-rest>
              <a-row :gutter="[10, 10]">
                <a-col v-for="(item, key) in platform" :key="key" :span="12">
                  <div
                    class="cursor-pointer platform-item"
                    @click="
                      () => {
                        publishForm.platform_type = item.platform_type
                      }
                    "
                  >
                    <div class="flex items-center">
                      <Resource
                        :src="replaceUrl(item?.avatar) || item?.icon"
                        class="w-[26px] h-[26px] mr-[10px] rounded-[8px]"
                      />
                      <a-radio
                        class="mr-[10px]"
                        :value="item.platform_type"
                        :checked="
                          item.platform_type === publishForm.platform_type
                        "
                      />
                      <span class="text-font-1">{{ item.name }}</span>
                      <!-- </div> -->
                    </div>
                    <div
                      v-if="
                        !item.auth_url &&
                        ![
                          PUBLISH_PLATFORM.XHS,
                          PUBLISH_PLATFORM.EMAIL,
                        ].includes(item.platform_type)
                      "
                      class="ml-[8px] flex-y-center"
                      @click="
                        (e) => {
                          e.stopPropagation()
                          emit('logout', item.platform_type)
                        }
                      "
                    >
                      <a-tooltip>
                        <template #title>
                          {{ $t('tui-chu-shou-quan') }}
                        </template>
                        <iconpark-icon
                          name="logout"
                          class="text-[18px]"
                        ></iconpark-icon>
                      </a-tooltip>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </a-form-item-rest>
          </a-form-item>
          <!-- <a-button @click="onShare">小红书</a-button> -->
          <div
            v-if="
              !bliarea?.length &&
              publishForm.platform_type === PUBLISH_PLATFORM.BLIBLI
            "
            class="mt-10px text-font-60"
          >
            {{
              $t(
                'zhubzhan-shou-quan-fa-bu-shi-pin-xu-gou-xuan-up-zhu-shi-pin-gao-jian-guan-li-quan-xian'
              )
            }}
          </div>
          <a-divider
            v-if="
              !publishForm.platform_type ||
              ![PUBLISH_PLATFORM.YOUTUBE, PUBLISH_PLATFORM.TIKTOK].includes(
                publishForm.platform_type
              )
            "
            class="my-16px"
          />
          <a-form-item
            v-if="publishForm.platform_type === PUBLISH_PLATFORM.KUAISHOU"
            :label="$t('fa-bu-miao-shu')"
            name="title"
            :rules="[
              { required: true, message: $t('qing-shu-ru-fa-bu-miao-shu') },
            ]"
          >
            <a-textarea
              v-model:value="publishForm.title"
              type="text"
              :placeholder="$t('qing-shu-ru-fa-bu-miao-shu')"
              :maxlength="300"
              :rows="4"
            ></a-textarea>
          </a-form-item>
          <a-form-item
            v-if="
              publishForm.platform_type &&
              [PUBLISH_PLATFORM.BLIBLI, PUBLISH_PLATFORM.XHS].includes(
                publishForm.platform_type
              )
            "
            :label="$t('fa-bu-biao-ti')"
            name="title"
            :rules="[{ required: true, message: $t('fa-bu-biao-ti') }]"
          >
            <a-input
              v-model:value="publishForm.title"
              type="text"
              :placeholder="$t('qing-shu-ru-fa-bu-biao-ti')"
              :maxlength="30"
            ></a-input>
          </a-form-item>
          <a-form-item
            v-if="
              publishForm.platform_type &&
              [PUBLISH_PLATFORM.BLIBLI, PUBLISH_PLATFORM.XHS].includes(
                publishForm.platform_type
              )
            "
            :label="$t('fa-bu-miao-shu')"
            name="desc"
          >
            <a-textarea
              v-model:value="publishForm.desc"
              type="text"
              :placeholder="$t('qing-shu-ru-fa-bu-miao-shu')"
              :maxlength="200"
              :rows="4"
            ></a-textarea>
          </a-form-item>

          <a-form-item
            v-if="Number(publishForm.platform_type) === PUBLISH_PLATFORM.BLIBLI"
            :label="$t('shi-pin-biao-qian')"
            name="b_tag"
          >
            <a-textarea
              v-model:value="publishForm.b_tag"
              type="text"
              :maxlength="200"
              :placeholder="
                $t(
                  'qing-shu-ru-shi-pin-biao-qian-duo-ge-yong-ying-wen-dou-hao-fen-ge'
                )
              "
            ></a-textarea>
          </a-form-item>
          <a-form-item
            v-if="
              Number(publishForm.platform_type) === PUBLISH_PLATFORM.BLIBLI &&
              bliarea?.length
            "
            :label="$t('fen-qu-xin-xi')"
            name="tid"
          >
            <a-cascader
              v-model:value="publishForm.tid"
              class="w-full"
              :options="bliarea"
              :placeholder="$t('qing-xuan-ze-fen-qu-xin-xi')"
              :fieldNames="{
                label: 'name',
                value: 'id',
              }"
            />
          </a-form-item>
          <a-form-item
            v-if="publishForm.platform_type === PUBLISH_PLATFORM.EMAIL"
            name="email"
            :label="$t('you-xiang-di-zhi')"
            :rules="[
              {
                required: true,
                message: $t('qing-shu-ru-you-xiang-di-zhi'),
              },
            ]"
          >
            <a-input
              v-model:value="publishForm.email"
              :placeholder="$t('qing-shu-ru-you-xiang-di-zhi')"
            />
          </a-form-item>
        </a-form>
      </div>
    </div>
    <a-divider class="my-0" />
    <div class="text-right p-[16px]">
      <a-button
        type="primary"
        ghost
        class="cancel-btn mr-[20px] yy-btn-outline"
        @click="onCancel"
      >
        {{ $t('qu-xiao') }}
      </a-button>
      <a-button
        type="primary"
        html-type="submit"
        :loading="loading"
        @click="onPublish"
      >
        {{ $t('que-ren') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { createPublish, createPublishForeign } from '@/api'
import { PUBLISH_PLATFORM, type UserPublishItem } from '~/api/interface/publish'
import { PageKey } from '~/constants/page'

interface IShareProps {
  data: PublishData
  platform: UserPublishItem[]
  bliarea: []
}
interface IShareBody {
  platform_type: PUBLISH_PLATFORM
  video_url?: string
  title: string
  desc: string
  cover_url?: string
  tid?: string[]
  b_tag?: string
  email: string
}

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 24 },
}
const timer = ref()

const publishForm = ref<Partial<IShareBody>>({
  platform_type: undefined,
  title: '',
  desc: '',
  b_tag: undefined,
  tid: [],
  email: '',
})
const loading = ref(false)

const props = defineProps<IShareProps>()
const emit = defineEmits(['success', 'logout', 'reload', 'cancel'])
const authWindow = ref()
const formRef = ref()
const showPublish = usePublishProcess()
const publishInfo = usePublishInfo()
const { $t } = useNuxtApp()

const currentPlatform: any = computed(() => {
  if (publishForm.value?.platform_type) {
    const platformInfo = props.platform.find(
      (i: any) => i.platform_type === Number(publishForm.value?.platform_type)
    )
    return platformInfo
  }
  return {}
})

const rules = {
  platform_type: [{ required: true, message: $t('qing-xuan-ze-ping-tai') }],
  // title: [{ required: true, message: '请输入标题' }],
  desc: [{ required: true, message: $t('qing-shu-ru-miao-shu') }],
  tid: [{ required: true, message: $t('qing-xuan-ze-fen-qu') }],
  b_tag: [
    {
      required: true,
      message: $t(
        'qing-shu-ru-shi-pin-biao-qian-duo-ge-yi-ying-wen-dou-hao-fen-ge'
      ),
    },
  ],
}
// 发布
const onPublish = async () => {
  const detail = await formRef.value?.validateFields()
  // 若当前平台未授权 授权弹窗
  if (currentPlatform.value?.auth_url) {
    startRoll()
    localSetItem('platform_type', publishForm.value?.platform_type)
    openAuth(currentPlatform.value?.auth_url)
    return
  }
  // B站平台必须授权条件
  if (
    !props.bliarea.length &&
    publishForm.value.platform_type === PUBLISH_PLATFORM.BLIBLI
  ) {
    message.warn(
      $t(
        'qing-xian-tui-chubzhan-bang-ding-zhong-xin-bang-ding-bing-gou-xuan-up-zhu-shi-pin-gao-jian-guan-li-quan-xian'
      )
    )
    return
  }
  loading.value = true
  const route = useRoute()

  trackEvent(TRACK_EVENT.CLICK_PUBLISH_CHENGPIAN, {
    source:
      route.name === PageKey.PERSONAL_SPACE
        ? SOURCE.MYSPACE
        : SOURCE.TEAM_SPACE,
    PublishTo: publishForm.value.platform_type,
  })
  try {
    if (isGlobalVersion()) {
      await createPublishForeign({
        ...detail,
        platform_type: publishForm.value.platform_type,
        generate_record_xihe_task_id: props.data.generate_record_task_id,
      })
    } else {
      await createPublish({
        ...detail,
        platform_type: publishForm.value.platform_type,
        video_url: props.data.url?.[0],
        cover_url: props.data.cover,
        tid: detail.tid
          ?.slice(detail.tid?.length - 1, detail.tid?.length)
          .toString(),
        notify_info: {
          room_type: publishInfo.value!.room_type,
          project_id: props.data.project_id,
          name: props.data.title,
        },
      })
    }

    message.success($t('cao-zuo-cheng-gong'))
    onReset()
    publishInfo.value = undefined
    showPublish.value = { ...props.data, id: uuid() }
    setProgress(PROGRESS_TYPE.PUBLISH, {
      show: true,
    })
    loading.value = false
  } catch (e) {
    console.error(e)

    loading.value = false
  }
}

const replaceUrl = (url: string | undefined) => {
  if (!url) {
    return
  }

  return url?.replace('http:', 'https:')
}

// onUnmounted(() => {
//   publishForm.value = {
//     platform_type: 1,
//     title: '',
//     desc: '',
//     b_tag: undefined,
//     tid: [],
//   }

//   timer.value && clearTimeout(timer.value)
// })

const onCancel = () => {
  emit('cancel')
  onReset()
}

const onReset = () => {
  timer.value && clearTimeout(timer.value)
  publishForm.value = {
    platform_type: 1,
    title: '',
    desc: '',
    b_tag: undefined,
    tid: [],
  }
}

const startRoll = () => {
  if (currentPlatform.value.auth_url) {
    timer.value = setTimeout(() => {
      emit('reload')
      startRoll()
    }, 1000 * 2)
  } else {
    timer.value && clearTimeout(timer.value)
  }
}

// 打开授权页面
const openAuth = (url: string) => {
  const iWidth = 950 // 弹出窗口的宽度;
  const iHeight = 620 // 弹出窗口的高度;

  const iTop = (window.screen.height - iHeight) / 2 // 获得窗口的垂直位置;
  const iLeft = (window.screen.width - iWidth) / 2

  authWindow.value = window.open(
    url,
    'publish',
    'height=' +
      iHeight +
      ',innerHeight=' +
      iHeight +
      ',width=' +
      iWidth +
      ',innerWidth=' +
      iWidth +
      ',top=' +
      iTop +
      ',left=' +
      iLeft +
      ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
  )
}
</script>

<style lang="scss" scoped>
.publish-form {
  .platform-item {
    @apply p-[10px] rounded-[8px] bg-back-2  justify-between flex-y-center;
  }
  .cover {
    @apply w-full  rounded-[8px];
    border: 1px solid var(--back-3);
  }
}
</style>
